import { render } from "./Advantage.vue?vue&type=template&id=00811050&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"

import "./Advantage.vue?vue&type=style&index=0&id=00811050&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00811050"]])

export default __exports__